import { createAction as toolkitCreateAction, PayloadActionCreator } from '@reduxjs/toolkit';

/**
 * Async action bundle: fetch/fetchPaging carry the request payload (F),
 * success carries the response payload (S), fail stays loose — sagas pass
 * [], {}, or nothing on error.
 */
export interface AsyncAction<F = any, S = any> {
  fetch: PayloadActionCreator<F>;
  fetchPaging: PayloadActionCreator<F>;
  success: PayloadActionCreator<S>;
  fail: PayloadActionCreator<any>;
}

export const createAsyncAction = <F = any, S = any>(type: string): AsyncAction<F, S> => {
  return {
    fetch: toolkitCreateAction<F>(type),
    fetchPaging: toolkitCreateAction<F>(type + '_PAGING'),
    success: toolkitCreateAction<S>(type + '_SUCCESS'),
    fail: toolkitCreateAction<any>(type + '_FAIL'),
  };
};
export const createAction = toolkitCreateAction;
